import { doCookieAuth } from './BaseVue';
import { setOrganizations } from './firebase';
import { MUT_IS_LOADING, MUT_PARENT_AUTH_TOKEN, MUT_SET_USER, store } from './store';
import { notifyParentReady, requestTokenFromParent } from './utils/iframeMessageRequester';

/**
 * Boot when the v3 shell hosts this window in an iframe. There is no session of our own —
 * v3 hands over its access token — so the org we land on is the one that token is for
 * (see setOrganizations), and once our listeners exist we ask v3 to confirm its current
 * org in case its first `orgChange` was sent before we could hear it (see
 * notifyParentReady). CIB-4184.
 */
export async function bootInsideParent(): Promise<void> {
  const parentToken = await requestTokenFromParent();
  await store.commit(MUT_PARENT_AUTH_TOKEN, parentToken);
  const user = await doCookieAuth();

  if (user) {
    store.commit(MUT_SET_USER, user);
    await setOrganizations(user);
  }
  store.commit(MUT_IS_LOADING, false);
  notifyParentReady();
}
